var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group" }, [
    _vm.position === "prefix"
      ? _c("div", { staticClass: "input-group-prepend" }, [
          _c("span", { staticClass: "input-group-text" }, [
            _vm._v(_vm._s(_vm.symbol))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "form-control",
      attrs: {
        type: "number",
        step: _vm.getStep,
        name: _vm.name,
        placeholder: _vm.placeholder
      },
      domProps: { value: _vm.value },
      on: { input: _vm.updateValue }
    }),
    _vm._v(" "),
    _vm.position === "suffix"
      ? _c("div", { staticClass: "input-group-append" }, [
          _c("span", { staticClass: "input-group-text" }, [
            _vm._v(_vm._s(_vm.symbol))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ad3c319", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad3c319","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/currency-input.vue
// module id = 481
// module chunks = 376